export default "data:font/ttf;base64,ZXhwb3J0IGRlZmF1bHQgX193ZWJwYWNrX3B1YmxpY19wYXRoX18gKyAiTWF0ZXJpYWxDb21tdW5pdHlJY29ucy50dGYiOw=="